import { CustomCheckBox } from './component'

export default CustomCheckBox
